import { VStack } from '@ayble-health/dashboard-components';
import { DashboardBlock, UserBlock } from '../../../models/block';
import { BlockCreateContent } from './BlockCreateContent';
import { BlockEditContent } from './BlockEditContent';
import { UserBlockAction } from './types';
import BlockDrawerHeader from 'components/UserDashboard/overview/BlockDrawerHeader';

type Props = {
  editableBlock: UserBlock | null;
  onBackToBlockList: () => void;
  onCreateBlock: (block: DashboardBlock) => void;
  onPatientInstructionsChange: (text: string) => void;
  onSelectBlock: (block: DashboardBlock) => void;
  patientInstructions: string;
  selectedBlock: DashboardBlock | null;
  handleUpdateUserBlock: () => void;
  handleUserBlockAction: (
    action: UserBlockAction,
    userBlockId?: string
  ) => void;
  closeBlockDrawer: () => void;
  drawerSubtitle: string;
  drawerHeader: string;
};

export const BlockDrawerContent = ({
  editableBlock,
  selectedBlock,
  onBackToBlockList,
  onCreateBlock,
  onPatientInstructionsChange,
  onSelectBlock,
  patientInstructions,
  handleUpdateUserBlock,
  handleUserBlockAction,
  closeBlockDrawer,
  drawerSubtitle,
  drawerHeader,
}: Props) => {
  const renderContent = () => {
    if (!!editableBlock) return <BlockEditContent block={editableBlock} />;

    if (!!selectedBlock) {
      return (
        <BlockCreateContent
          onCreateBlock={onCreateBlock}
          onPatientInstructionsChange={onPatientInstructionsChange}
          onSelectBlock={onSelectBlock}
          patientInstructions={patientInstructions}
          selectedBlock={selectedBlock}
        />
      );
    }

    return null;
  };

  return (
    <VStack h={'100%'}>
      <BlockDrawerHeader
        patientInstructions={patientInstructions}
        closeBlockDrawer={closeBlockDrawer}
        editableBlock={editableBlock}
        selectedBlock={selectedBlock}
        handleUserBlockAction={handleUserBlockAction}
        onBackToBlockList={onBackToBlockList}
        onPatientInstructionsChange={onPatientInstructionsChange}
        drawerSubtitle={drawerSubtitle}
        handleUpdateUserBlock={handleUpdateUserBlock}
        drawerHeader={drawerHeader}
      />

      <VStack flex={1} minH={0}>
        {renderContent()}
      </VStack>
    </VStack>
  );
};
